"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _slicedToArray2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));
var _dayjs = _interopRequireDefault(require("dayjs"));
var _order = require("@/api/marketingFunction/superSubsidyV2/order");
var _activity = require("@/api/marketingFunction/superSubsidyV2/activity");
var _wedding = require("@/api/wedding");
var _platformOption = require("@/utils/platformOption");
var _GoodsInfoCell = _interopRequireDefault(require("./components/GoodsInfoCell.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 统一文件导出框架入口已在 @/api/wedding 定义（同一 URL 全局唯一），此处复用

// 付款时间默认选中最近七天
function defaultTimeRange() {
  return [(0, _dayjs.default)().subtract(7, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss'), (0, _dayjs.default)().endOf('day').format('YYYY-MM-DD HH:mm:ss')];
}

// 快捷区间：距今 days 天的 00:00:00 至今天 23:59:59（days 为 0 表示今天）
function shortcutRange(days) {
  return [(0, _dayjs.default)().subtract(days, 'day').startOf('day').toDate(), (0, _dayjs.default)().endOf('day').toDate()];
}

// 快捷区间：指定偏移当天 00:00:00 至 23:59:59（offset 为 1 表示昨天）
function dayRange(offset) {
  return [(0, _dayjs.default)().subtract(offset, 'day').startOf('day').toDate(), (0, _dayjs.default)().subtract(offset, 'day').endOf('day').toDate()];
}

// 订单列表查询条件（默认付款时间最近七天，timeRange 仅用于选择器展示）
function createQueryData() {
  var _defaultTimeRange = defaultTimeRange(),
    _defaultTimeRange2 = (0, _slicedToArray2.default)(_defaultTimeRange, 2),
    payTimeStart = _defaultTimeRange2[0],
    payTimeEnd = _defaultTimeRange2[1];
  return {
    orderNo: '',
    title: '',
    goodsId: '',
    memberId: '',
    platformCode: '',
    activityId: '',
    timeRange: [payTimeStart, payTimeEnd],
    payTimeStart: payTimeStart,
    payTimeEnd: payTimeEnd,
    page: 1,
    size: 20
  };
}
var _default = exports.default = {
  name: 'SuperSubsidyV2Order',
  components: {
    GoodsInfoCell: _GoodsInfoCell.default
  },
  data: function data() {
    return {
      platformOption: _platformOption.PLATFORM_OPTION,
      // 付款时间快捷区间：今天 / 昨天 / 最近七天 / 一个月 / 三个月
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick: function onClick(picker) {
            picker.$emit('pick', shortcutRange(0));
          }
        }, {
          text: '昨天',
          onClick: function onClick(picker) {
            picker.$emit('pick', dayRange(1));
          }
        }, {
          text: '最近七天',
          onClick: function onClick(picker) {
            picker.$emit('pick', shortcutRange(7));
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            picker.$emit('pick', shortcutRange(30));
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            picker.$emit('pick', shortcutRange(90));
          }
        }]
      },
      queryData: createQueryData(),
      tableData: [],
      tableLoading: false,
      total: 0,
      activityOption: [],
      exportLoading: false,
      listSeq: 0 // 列表取数序号：仅最新一次请求可写入表格，丢弃过期响应
    };
  },
  computed: {
    // 渠道编码 -> 展示名（与商品页共用同一份映射）
    platformMapping: function platformMapping() {
      return _platformOption.PLATFORM_NAME_MAP;
    }
  },
  created: function created() {
    this.getActivityOption();
    this.getOrderList();
  },
  methods: {
    // 所属活动筛选项
    getActivityOption: function () {
      var _getActivityOption = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _activity.activitySelect)({});
            case 1:
              res = _context.v;
              this.activityOption = res.data || [];
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getActivityOption() {
        return _getActivityOption.apply(this, arguments);
      }
      return getActivityOption;
    }(),
    // 列表与导出共用查询条件；timeRange 仅用于日期选择器展示，不下发
    buildQueryParams: function buildQueryParams() {
      var params = (0, _objectSpread2.default)({}, this.queryData);
      delete params.timeRange;
      return params;
    },
    // 订单分页查询：条件与导出共用，后端按付款时间倒序
    getOrderList: function () {
      var _getOrderList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var seq, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              seq = ++this.listSeq;
              _context2.p = 1;
              this.tableLoading = true;
              _context2.n = 2;
              return (0, _order.orderList)(this.buildQueryParams());
            case 2:
              res = _context2.v;
              if (!(seq !== this.listSeq)) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2);
            case 3:
              this.tableData = res.data.data || [];
              this.total = res.data.total || 0;
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t2 = _context2.v;
              console.log(_t2);
            case 5:
              _context2.p = 5;
              if (seq === this.listSeq) {
                this.tableLoading = false;
              }
              return _context2.f(5);
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 4, 5, 6]]);
      }));
      function getOrderList() {
        return _getOrderList.apply(this, arguments);
      }
      return getOrderList;
    }(),
    // 查询：回到第一页
    onInquire: function onInquire() {
      this.queryData.page = 1;
      this.getOrderList();
    },
    // 重置查询条件（含默认最近七天）并刷新
    onInitialize: function onInitialize() {
      this.queryData = createQueryData();
      this.getOrderList();
    },
    // 日期区间变化同步到查询参数；清空时提交空值
    onTimeChange: function onTimeChange(val) {
      if (val && val.length === 2) {
        this.queryData.payTimeStart = val[0];
        this.queryData.payTimeEnd = val[1];
      } else {
        this.queryData.payTimeStart = '';
        this.queryData.payTimeEnd = '';
      }
    },
    // 每页条数变化
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.size = val;
      this.getOrderList();
    },
    // 页码变化
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page = val;
      this.getOrderList();
    },
    // 会员详情
    onUserDetails: function onUserDetails(row) {
      this.$router.push({
        path: '/member/userDetails',
        query: {
          memberId: row.memberId,
          nickname: row.memberName
        }
      });
    },
    // 订单详情
    onOrderDetails: function onOrderDetails(row) {
      this.$router.push({
        path: '/orderManagement/orderDetails',
        query: {
          orderNo: row.orderNo,
          unionCode: row.platformCode
        }
      });
    },
    // 订单导出：条件与列表筛选一致，同步导出返回下载地址
    onExport: function () {
      var _onExport = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (!this.exportLoading) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              this.exportLoading = true;
              _context3.p = 2;
              // 导出条件与列表筛选一致，不含分页
              params = this.buildQueryParams();
              delete params.page;
              delete params.size;
              _context3.n = 3;
              return (0, _wedding.export_order)({
                moduleId: 5,
                exportType: 1,
                querySnapshot: params
              });
            case 3:
              res = _context3.v;
              if (res.data && res.data.downloadUrl) {
                window.open(res.data.downloadUrl, '_blank');
              } else {
                this.$message.warning('导出失败，请稍后重试');
              }
              _context3.n = 5;
              break;
            case 4:
              _context3.p = 4;
              _t3 = _context3.v;
              console.log(_t3);
            case 5:
              _context3.p = 5;
              this.exportLoading = false;
              return _context3.f(5);
            case 6:
              return _context3.a(2);
          }
        }, _callee3, this, [[2, 4, 5, 6]]);
      }));
      function onExport() {
        return _onExport.apply(this, arguments);
      }
      return onExport;
    }()
  }
};